import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpResponse,
  HttpUserEvent,
  HttpErrorResponse,
  HttpEvent
} from '@angular/common/http';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthenticationService } from './authentication.service';
import { environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestInterceptor implements HttpInterceptor {


  dialogSessionExpiredInProgress = false;
  dialogSessionExpiredSource = new Subject();
  dialogSessionExpired$ = this.dialogSessionExpiredSource.asObservable();

  constructor(
    private authService: AuthenticationService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {

    if (!req.url.startsWith('/api/token')) {
      req = this.addAuthorizationHeader(req);
    }

    // Handle response
    return next.handle(req).pipe(catchError(error => {
      return this.handleResponseError(error, req, next);
    }));
  }

  addAuthorizationHeader(req: HttpRequest<any>): HttpRequest<any> {
    if (!this.authService.isAuthenticated()) {
      return req;
    }

    return req.clone({
      setHeaders: {
        Authorization: this.authService.getAuthorizationHeader()
      }
    });
  }

  handleResponseError(err: any, req?: HttpRequest<any>, next?: HttpHandler): Observable<HttpEvent<any>> {
    let error = err;

    if (!(error instanceof HttpErrorResponse)) {
      error = err.cause;
    }

    if (!(error instanceof HttpErrorResponse)) {
      // Return principal error, this is not a http error response
      return throwError(err);
    }

    if (error.status === 401 && req) {
      return this.authService.refresh()
        .pipe(
          switchMap((ok) => {
            if (!ok) {
              this.authService.redirectToLogin();
            }
            return next.handle(this.addAuthorizationHeader(req));
          }),
          catchError(e => {
            return this.handleResponseError(e);
          })
        );
    }

    return throwError(err);

  }
}
